import {
    FETCH_ALL_DRAFTS,
    FETCH_ALL_DRAFTS_LOADING,
    FETCH_DRAFT,
    CREATE_DRAFT,
    ROOT_URL,
} from "./actions-index";
import axios from "axios/index";

export function receivedAllDrafts(draftList) {
    return {
        type: FETCH_ALL_DRAFTS,
        payload: draftList
    };
}

export function allDraftsLoading(isLoading) {
    return {
        type: FETCH_ALL_DRAFTS_LOADING,
        payload: isLoading
    };
}

export function receivedDraft(draft) {
    return {
        type: FETCH_DRAFT,
        payload: draft
    };
}

export function createdDraft(draft) {
    return {
        type: CREATE_DRAFT,
        payload: draft
    };
}

export function fetchAllDrafts() {
    return function (dispatch) {
        dispatch(allDraftsLoading(true));
        return axios.get(`${ROOT_URL}/draft-list`)
            .then(response => {
                dispatch(allDraftsLoading(false));
                if (response) {
                    dispatch(receivedAllDrafts(response.data));
                } else {
                    console.log('an error occurred while fetching draft-list');
                }
            });
    }
}

export function fetchDraft(draftId) {
    return function (dispatch) {
        return new Promise((resolve, reject) => {
            return axios.get(`${ROOT_URL}/draft/${draftId}`)
                .then(response => {
                    if (response) {
                        resolve(dispatch(receivedDraft(response.data)));
                    } else {
                        console.log('an error occurred while fetching /draft/' + draftId);
                    }
                });
        });
    }
}

export function createDraft(values) {
    return function (dispatch) {
        return new Promise((resolve, reject) => {
            let rounds = [];
            values.rounds.forEach((round, roundIndex) => {
                let picks = [];
                round.picks.forEach((pick, pickIndex) => {
                    let details = [];
                    pick.details.forEach((detail, detailIndex) => {
                        details.push({
                            team: detail.team ? detail.team : null,
                            notes: detail.notes ? detail.notes : null
                        })
                    });
                    let draftPick = pick.draftPick
                    picks.push({
                        draftPick: draftPick && typeof draftPick === "string" ? draftPick : (draftPick ? draftPick.fullName : null),
                        details: details ? details : null
                    });
                });
                rounds.push({
                    picks: picks ? picks : null,
                })
            });

            axios.post(`${ROOT_URL}/draft`, {
                id: values.id,
                year: values.year,
                championTeamId: values.championTeamId,
                recap: values.recap,
                rounds: rounds ? rounds : [],
            }).then(response =>{
                if (response) {
                    resolve(dispatch(createdDraft(response.data)));
                } else {
                    console.log('an error occurred while creating /draft');
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/actions/actions-draft.js